<div class="row d-flex">
    <div class="col-12 d-none d-md-block">
        <div class="row row-cols-2 row-cols-md-2">

        <div class="col px-3 pb-5 mb-1" *ngFor="let slide of slides; index as i">
            <div class="card shadow-sm h-100">
                <img loading="lazy" [src]="slide?.poster" [alt]="slide.poster_alt ? slide.poster_alt : slide.title"
                     class="card-img-top" />
                <div class="card-body position-relative" style="padding: 2.5rem 1.5rem 1rem;">
                    <span class="position-absolute badge badge-pill bg-white shadow-sm font-size-25 font-weight-bold w-50px"
                        style="top: -35px;">
                        {{ i + 1 }}
                    </span>
                    <h3 class="card-title font-size-25 mb-3">
                        {{ slide?.title }}
                    </h3>
                    <p class="card-text font-size-14 text-left mb-0">
                        {{ slide?.description }}
                    </p>
                </div>
                <div class="card-footer border-0">
                    <p class="text-left" *ngIf="slide?.url">
                        <a routerLink="{{ slide?.url }}">
                            <button class="btn btn-outline-primary border-primary border-2 rounded-pill font-size-16 font-weight-bold">
                                Learn More <!--<img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg">-->
                            </button>
                        </a>
                    </p>
                </div>
            </div>
        </div>

        </div>
    </div>
    <div class="col-12 d-md-none">
        <swiper
        [config]="standardConfig"
        (swiper)="onWaySwiper($event)"
        (slideChange)="onWaySlideChange()"
        class="w-100"
        >
            <ng-template swiperSlide *ngFor="let slide of slides; index as i">
                <!--<div class="w-100 h-100 d-flex flex-column">-->
                    <div class="card shadow-xs h-100">
                        <img loading="lazy" [src]="slide?.poster" [alt]="slide.poster_alt ? slide.poster_alt : slide.title"
                             class="card-img-top" />
                        <div class="card-body position-relative" style="padding: 2.5rem 1.5rem 1rem;">
                        <span class="position-absolute badge badge-pill bg-white shadow-sm font-size-25 font-weight-bold w-50px"
                              style="top: -35px;">
                            {{ i + 1 }}
                        </span>
                            <h3 class="card-title font-size-20 mb-3">
                                {{ slide?.title }}
                            </h3>
                            <p class="card-text font-size-14 text-left mb-0">
                                {{ slide?.description }}
                            </p>
                        </div>
                        <div class="card-footer border-0">
                            <p class="text-left" *ngIf="slide?.url">
                                <a routerLink="{{ slide?.url }}">
                                    <button class="btn btn-outline-primary border-primary border-2 rounded-pill font-size-16 font-weight-bold">
                                        Learn More <!--<img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg">-->
                                    </button>
                                </a>
                            </p>
                        </div>
                    </div>
                <!--</div>-->
            </ng-template>
        </swiper>
    </div>
</div>